// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'

// this is a thunk which reinitializes the specified formName
// it is used to support pagination in <SearchAndSelect />
// and ensures that triggerSearch can handle properly

const reInitializeForm = formName => async (dispatch, getState) => {
  const { values } = getState().form[formName]

  // keepDirty - mark the entire form as pristine.
  // keepSubmitSucceeded - persist whatever submitSucceeded's value was.
  await dispatch(initialize(formName, values, {
    keepDirty: false,
    keepSubmitSucceeded: true,
  }))
}

export default reInitializeForm
